export enum ContactsPlace {
  Site = 'site',
  Permitting = 'permitting',
}
